import { BINLoader } from "./BinLoader";
import { BVHLoader } from "./BVHLoader";
import {  
  PointCloudType,
  TLoader,
} from "./interface";
import { LASLoader } from "./LASLoader";
import { PLYLoader } from "./PLYLoader";

export class PointCloudLoaderFactory {
  private _loaderMap: Map<PointCloudType, TLoader>;
  constructor() {
    this._loaderMap = new Map();
  }

  getLoader(type: PointCloudType):TLoader  {
    const loader = this._loaderMap.get(type);
    if (loader) {
      return loader;
    }
    let _loader;
    switch (type) {
      case PointCloudType.STREAM:
        _loader = new BVHLoader();
        break;
      case PointCloudType.STREAM_BIN:
        _loader = new BINLoader();
        break;
      case PointCloudType.LAS:
        _loader = new LASLoader();
        break;
      case PointCloudType.PLY:
        _loader = new PLYLoader();
        break;
      default:
        throw ({message: "Loader not Found"});

    }
    this._loaderMap.set(type, _loader);
    return _loader;
  }
}
